export default {
  runSingleVariantFilter(state, commit, filterId) {
    state.cardsFiltered.forEach(card => {
      let singleOptionResults = []

      // If no option is selected, return all available variants
      if (!state.variantFilters.selected[filterId].length)
        return (singleOptionResults = card.variants)

      card.variants.forEach(variant => {
        state.variantFilters.selected[filterId].forEach(option => {
          // Special case for primary filter with 'All ...'
          if (option === '') return (singleOptionResults = card.variants)
          let values =
            filterId.indexOf('size') > -1
              ? variant.size.filter(size => size.stock > 0).map(sizes => sizes.size)
              : variant[filterId]
          if (values.includes(option)) singleOptionResults.push(variant)
        })
      })

      // Find only unique object in array - alternative approach for new Set(...) that doesn't work in IE11
      let uniqueStartingPoint = []
      let uniqueResults = singleOptionResults.filter(result => {
        if (!uniqueStartingPoint.includes(result.id)) {
          uniqueStartingPoint.push(result.id)
          return true
        } else {
          return false
        }
      })

      // Commit single filter result (only unique values)
      commit('setFilteredVariants', {
        id: card.id,
        variants: uniqueResults,
      })
    })
  },

  runAllSingleItemFilters(state, commit) {
    Object.keys(state.itemFilters.selected).forEach(filterKey => {
      this.runSingleItemFilter(state, commit, filterKey)
    })
  },

  // Run single filter and save results in state.itemFilters.results[filterId]
  runSingleItemFilter(state, commit, filterId) {
    let combinedFilterResult = []
    let length = state.itemFilters.selected[filterId].length

    // If no filter is set, the result equals all available cards for that filter
    if (length === 0) {
      combinedFilterResult = state.cards
    } else {
      // Loop over all options per filter
      state.itemFilters.selected[filterId].forEach(option => {
        let singleOptionResults = []

        // Result per single option is either the matching cards or all cards if option is not selected
        // Empty case only applies for primary filters (All ...)
        singleOptionResults =
          option !== ''
            ? state.cardsFiltered.filter(card => card.tags.includes(option))
            : state.cards

        // Options are additive
        // => add results per option to combined filter result if not included yet
        singleOptionResults.forEach(card => {
          if (!combinedFilterResult.includes(card)) {
            combinedFilterResult.push(card)
          }
        })
      })
    }

    // Commit single filter result
    commit('setItemResults', {
      id: filterId,
      value: combinedFilterResult,
    })
  },

  // Expects an array of arrays and returns all elements present in all arrays
  buildIntersection(payload) {
    return payload.reduce((p, c) => p.filter(e => c.includes(e)))
  },

  // Gather all single filter results in one array
  concatFilters(filters) {
    let concatedFilters = []
    Object.keys(filters).forEach(key => {
      concatedFilters.push(filters[key])
    })
    return concatedFilters
  },

  buildResults(state, commit) {
    let intersectedFilters = []

    if (Object.keys(state.itemFilters.results).length === 0) {
      // If no itemFilters are defined on the filter page, show all available cards
      intersectedFilters = state.cards
    } else {
      let concatenatedFilters = this.concatFilters(state.itemFilters.results)
      intersectedFilters = this.buildIntersection(concatenatedFilters)
    }

    // Single filters are subtractive
    // => determine intersection of all single filter results
    commit('setFilteredCards', JSON.parse(JSON.stringify(intersectedFilters)))
  },

  determineHiddenSecondaries(state, commit) {
    let hiddenSecondaries = []

    state.secondaryFilters.forEach(secondary => {
      let conditonsMet = []

      // Check if secondary filter meets at least one exclusion criteria
      Object.keys(secondary.excludeIf).forEach(condition => {
        state.activePrimaryFilters.forEach(activeFilter => {
          if (secondary.excludeIf[condition].includes(activeFilter[condition])) {
            conditonsMet.push(true)
          }
        })
      })

      // If so add filter to the hidden secondaries filters
      if (conditonsMet.length > 0) {
        hiddenSecondaries.push(secondary.id)
      }
    })
    commit('setHiddenSecondaries', hiddenSecondaries)
  },

  getCurrentSubPage(subPages, activeFilters) {
    // activeFilters and subPage must have same length && all filters must be equal
    let currentSubPage = subPages.filter(subPage => {
      if (subPage.filterMatches.length !== activeFilters.length) return false
      return activeFilters.every(filter => subPage.filterMatches.includes(filter))
    })

    // Fallback to the case with no selected filters if no matching subPage could be found
    return currentSubPage.length > 0 ? currentSubPage : this.getCurrentSubPage(subPages, [])
  },

  deepCopyVariants(state) {
    state.cardsFiltered.forEach(filteredCard => {
      let blueprintIndex = state.cards.findIndex(blueprint => blueprint.id === filteredCard.id)
      let blueprintVariants = JSON.parse(JSON.stringify(state.cards[blueprintIndex].variants))
      filteredCard.variants = blueprintVariants
    })
  },

  getSortedCards(cardsFiltered, currentSorting) {
    let cf = JSON.parse(JSON.stringify(cardsFiltered))
    this.resetDisplayedVariant(cf)
    if (currentSorting === 'highprice') cf = cf.sort((card1, card2) => card2.price - card1.price)
    else if (currentSorting === 'lowprice') cf = cf.sort((card, card2) => card.price - card2.price)
    else if (currentSorting === 'bestseller')
      cf = this.setMaxSale(cf).sort((c1, c2) => c2.maxSale - c1.maxSale)

    On.Analytics.trackSorting(currentSorting)
    return cf
  },

  getCardsWithoutEmptyVariants(cardsFiltered) {
    const cardsWithoutEmptyVariants = JSON.parse(JSON.stringify(cardsFiltered))
    return cardsWithoutEmptyVariants.filter(card => card.variants.length)
  },

  getCardsWithPromoCards(cardsFiltered, currentBreakpoint, promoCards) {
    const cardsFilteredWithPromos = JSON.parse(JSON.stringify(cardsFiltered))
    currentBreakpoint.promoPositions.forEach((position, index) => {
      if (position < cardsFilteredWithPromos.length && promoCards[index]) {
        cardsFilteredWithPromos.splice(position, 0, promoCards[index])
      }
    })
    return cardsFilteredWithPromos
  },

  reportLoadingOfProducts(state) {
    const productData = state.cardsFiltered.reduce((data, card) => {
      const mainVariant =
        card.variants.filter(v => v.id == card.mainVariantId)[0] || card.variants[0]

      if (mainVariant) {
        data.push({
          id: card.id,
          name: card.name,
          sku: mainVariant.productData.sku,
          groupName: mainVariant.productData.groupName,
          productName: mainVariant.productData.name,
          productType: mainVariant.productData.productType,
        })
      }
      return data
    }, [])

    On.Analytics.trackListView('Filter Page', window.document.location.pathname, productData)
  },

  // NAVIGATION
  composeUrl(state) {
    const concatenatePathFilters = (concatFilters, filterName) => {
      if (filterName !== '') {
        concatFilters = concatFilters + filterName + '/'
      }
      return concatFilters
    }

    const concatenateQueryFilters = (concatFilters, filter, currentIndex, array) => {
      // Add "?" symbol only once in the beginning and only if any queryFilters are present
      if (array.length !== 0 && currentIndex === 0) concatFilters = concatFilters + '?'
      concatFilters = concatFilters + Object.keys(filter)[0] + '=' + Object.values(filter)[0]
      if (currentIndex < array.length - 1) {
        concatFilters = concatFilters + '&'
      }
      return concatFilters
    }

    const concatenatedPathFilters = state.pathFilters
      .reduce(concatenatePathFilters, '')
      // Slice final "/" symbol
      .slice(0, -1)

    const concatenatedQueryFilters = state.queryFilters.reduce(concatenateQueryFilters, '')

    const sortSeparatorSymbol = concatenatedQueryFilters === '' ? '?' : '&'
    // Convention: don't show sorting in url if default sorting "featured" is set
    const sortPath =
      state.currentSorting !== 'featured'
        ? `${sortSeparatorSymbol}sort=${state.currentSorting}`
        : ''
    return `${state.basePath}${concatenatedPathFilters}${concatenatedQueryFilters}${sortPath}`
  },

  checkGeneralFilters(state) {
    // Loop all selected filters and save them according to if they belong in the path or in the query of the url
    let pathFilters = []
    let queryFilters = []
    let key = ''
    ;[state.itemFilters.selected, state.variantFilters.selected].forEach(filters => {
      Object.keys(filters).forEach(filterName => {
        state.allFilters.forEach(filter => {
          if (filters[filterName].length && filter.id === filterName) {
            // Collect all pathFilters but 'gender' and 'product'
            if (filter.includedInPath) {
              if (filterName !== 'gender' && filterName !== 'product') {
                filters[filterName].forEach(filterValue => pathFilters.push(filterValue))
              }
              // Collect queryFilters
            } else if (!filter.includedInPath) {
              filters[filterName].forEach(filterValue => {
                // Take care of special case 'size' => use key instead of value
                if (filterName.indexOf('size') > -1) {
                  key = Object.values(
                    filter.values.find(sizePair => Object.keys(sizePair)[0] === filterValue)
                  )[0]
                  // key = Object.values(filterPair)[0];
                } else {
                  key = filterValue
                }
                queryFilters.push({
                  [filterName]: key,
                })
              })
            }
          }
        })
      })
    })
    return { pathFilters, queryFilters }
  },

  checkGenderAndProductFilters(state, pathFilters) {
    // Add 'gender' and 'product' to the beginning of pathFilters array as they have to be displayed first in URL
    [state.itemFilters.selected['product'], state.variantFilters.selected['gender']].forEach(
      filter => {
        if (filter !== undefined && filter[0] !== '') {
          filter.forEach(filterValue => pathFilters.unshift(filterValue))
        }
      }
    )
    return pathFilters
  },

  getPathAndQueryFilters(state) {
    let filters = this.checkGeneralFilters(state)
    let pathFilters = this.checkGenderAndProductFilters(state, filters.pathFilters)
    return { pathFilters, queryFilters: filters.queryFilters }
  },

  setMaxSale(cards) {
    cards.forEach(card => {
      if (card.variants.length > 0) {
        const variantWithMostItemsSold = card.variants.reduce((prev, current) =>
          prev.soldItems > current.soldItems ? prev : current
        )
        card.maxSale = variantWithMostItemsSold.soldItems
        card.displayedVariantId = variantWithMostItemsSold.id
      }
    })
    return cards
  },

  resetDisplayedVariant(cards) {
    cards.forEach(card => (card.displayedVariantId = card.mainVariantId))
  },

  // Retrieve information for tags from selected item and variant filters
  createTagsFromFilters({ state, filters, tags, level }) {
    Object.keys(filters).forEach(key => {
      if (filters[key].length && filters[key][0] !== '') {
        filters[key].forEach(valueId => {
          // Make sure no tags for primary filters get created
          if (!this.isPrimaryFilter(state, key)) {
            tags.push({
              filterId: key,
              level: level,
              value: '',
              valueId: valueId,
            })
          }
        })
      }
    })
    return tags
  },

  // Filter values can't be extracted directly from selected item & variant filters -
  // we have to get it from the secondary filters
  setTagValues(state, tags) {
    tags.forEach(tag => {
      let secondary = state.secondaryFilters.filter(secondary => secondary.id === tag.filterId)
      secondary[0].values.forEach(value => {
        // Shoe sizes need special treatment due to different international sizing
        const valueToCompare =
          secondary[0].id.indexOf('size_shoes') > -1
            ? Object.keys(value)[0]
            : Object.values(value)[0]
        if (valueToCompare === tag.valueId) tag.value = Object.keys(value)[0]
      })
    })
    return tags
  },

  isPrimaryFilter(state, key) {
    return state.primaryFilters.find(filter => filter.id === key)
  },
}
